import Vue from 'vue'
import App from './App'
import router from './router'
import "vue2-toast/lib/toast.css";
import Toast from "vue2-toast";
Vue.use(Toast);
Vue.config.productionTip = false
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js